module.exports = __webpack_public_path__ + "static/media/IconoPila2.575e133e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/gbadicionales/IconoPila2.svg
// module id = 755
// module chunks = 0